<template>
  <div id="topNav">
    <div
      class="menuBtn"
      :class="{ active: showMenu }"
      @click="showMenu = !showMenu"
    >
      <span class="menuLine"></span>
      <span class="menuLine"></span>
      <span class="menuLine"></span>
    </div>
    <div class="logos">
      <img src="@/assets/icons/Logomark.svg" />
      <h2>Raysbaseball.com</h2>
      <div>
        <h4>888.FAN.RAYS</h4>
      </div>
    </div>
    <div class="right">
      <div class="extLinks" :class="{ active: showMenu }">
        <a href="https://www.facebook.com/Rays/" target="_blank">
          <img src="@/assets/icons/app/facebook.svg" />
        </a>
        <a href="https://twitter.com/RaysBaseball" target="_blank"
          ><img src="@/assets/icons/app/twitter.svg"
        /></a>
        <a href="https://www.instagram.com/raysbaseball/" target="_blank"
          ><img src="@/assets/icons/app/instagram.svg"
        /></a>
      </div>
    </div>
    <div class="primaryNav" :class="{ active: showMenu }">
      <div id="primary-nav" :class="{ active: showMenu }">
        <div class="topNavLogos">
          <h2>Raysbaseball.com</h2>
          <h4>888.FAN.RAYS</h4>
        </div>
        <b-nav v-b-scrollspy="{ offset: 200 }" @activate="hi">
          <div class="p-nav-links">
            <b-nav-item
              class="p-nav-link"
              v-for="(link, index) in activeNavLinks"
              :key="'p-nav' + index"
              :href="link.to"
              v-scroll-to="{ el: link.to, offset: link.offset }"
              @click="updateNav(link.id)"
            >
              {{ link.title }}
            </b-nav-item>
          </div>
        </b-nav>
        <div class="bottomIcons">
          <a href="https://www.facebook.com/Rays/" target="_blank"
            ><img src="@/assets/icons/app/facebook.svg"
          /></a>
          <a href="https://twitter.com/RaysBaseball" target="_blank"
            ><img src="@/assets/icons/app/twitter.svg"
          /></a>
          <a href="https://www.instagram.com/raysbaseball/" target="_blank"
            ><img src="@/assets/icons/app/instagram.svg"
          /></a>
        </div>
      </div>
    </div>
    <div
      class="navOverlay"
      @click="showMenu = !showMenu"
      :class="{ active: showMenu }"
    ></div>
  </div>
</template>

<script>
import { navData } from "@/data/navData";
import { mapState } from "vuex";
export default {
  name: "TopNav",
  computed: {
    ...mapState(["global"]),
    activeNavLinks: function () {
      return this.$store.state.epitch.getPrimaryNav.map((item) => {
        return this.primaryLinks.find((link) => link?.title === item);
      });
    },
  },
  data() {
    return {
      primaryLinks: navData().primaryLinks,
      showMenu: false,
      credit: null,
      rep: null,
      repEmail: null,
      repPhone: null,
      reps: ["Kenzie Dill", "Emilee Bell", "Matt Gianoni", "Megan Paul"],
    };
  },
  created() {
    let userInfo = this.$store.state.global.userInfo;
    this.credit = userInfo.Total_Credit;
    this.rep = userInfo.Rep;
    this.repEmail = userInfo.Rep_Email;
    this.repPhone = userInfo.Rep_Phone_Number;
    // this.$root.$on("bv::scrollspy::activate", this.onActivate);
  },
  methods: {
    hi() {
      console.log("hi");
    },
    updateNav(sectionId) {
      this.showMenu = !this.showMenu;
      //this.$store.dispatch("updateSection", sectionId);
      this.$store.dispatch("postTracking", sectionId);
    },
  },
};
</script>

<style lang="scss" scoped>
#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 80px;
  z-index: 999;
  display: flex;
  background-color: $dark-blue;
  .right {
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-right: 40px;
    button {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 145%;
      display: flex;
      align-items: center;
      text-align: center;
      text-transform: uppercase;
      color: #00285e;
      width: auto;
      margin-inline: auto;
      border: 2px solid #00285e;
      border-radius: 50px;
      /* padding: 8px 30px; */
      /* margin-top: 50px; */
      background: #ffd200;
      border: none;
      padding: 12px 30px;
      white-space: nowrap;
      a {
        color: #00285e;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .menuBtn {
    position: relative;
    /* position: absolute; */
    left: 0;
    top: 0;
    width: 90px;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1001;
    transition: all 0.3s ease-in-out;
    margin-right: 20px;
    &.active {
      left: 250px;
      @media only screen and (max-width: $sm) {
        left: 240px;
      }
      .menuLine {
        &:first-child {
          transform: rotate(45deg);
          top: 47.5%;
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:last-child {
          transform: rotate(-45deg);
          bottom: 47.5%;
        }
      }
    }
    .menuLine {
      position: relative;
      background-color: $dark-blue;
      height: 4px;
      width: 30%;
      border-radius: 3px;
      &:first-child {
        position: absolute;
        top: 33%;
        transition: all 0.3s ease-in-out;
      }
      &:nth-child(2) {
        position: absolute;
        opacity: 1;
        transition: all 0.3s ease-in-out;
      }
      &:last-child {
        position: absolute;
        bottom: 33%;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .repInfo {
    margin-inline: 15px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    @media only screen and (max-width: "1450px") {
      display: none;
    }
    .active {
      opacity: 0;
    }
    img {
      float: left;
      width: 50px;
      height: 50px;
    }
    p {
      margin-left: 65px;
      &.repName {
        font-family: "Futura";
        font-size: 14px;
        color: $light-blue;
        margin-top: 5px;
      }
      &.repContact {
        font-family: "Futura";
        font-size: 16px;
        color: #fff;
        white-space: nowrap;
        a {
          font-family: "Futura";
          font-size: 14px;
          color: #fff;
          text-decoration: underline;
        }
      }
    }
  }
  .logos {
    /* position: absolute; */
    /* left: 115px;
    top: 25px; */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline: 15px 40px;
    @media only screen and (max-width: $md) {
      position: absolute;
      right: 0;
      top: 15px;
    }
    h2,
    h4 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      text-transform: uppercase;
      color: #79bde8;
      @media only screen and (max-width: $md) {
        display: none;
      }
    }
    h4 {
      color: #dad9d7;
      margin-left: 20px;
    }
    img {
      width: 60px;
      margin: 0 20px;
    }
  }
  .deadlines {
    @media only screen and (max-width: 1098px) {
      zoom: 0.8;
    }
    @media only screen and (max-width: 1000px) {
      display: none;
    }
    /* margin-top: 30px; */
    /* position: absolute; */
    /* right: 80px; */
    /* top: 0px; */
    .active {
      opacity: 0;
    }
    h2 {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      @media only screen and (max-width: $lg) {
        font-size: 14px;
      }
      line-height: 21px;
      display: flex;
      align-items: center;
      text-align: center;
      text-transform: uppercase;
      color: #ffd200;
      span {
        color: #dad9d7;
        margin-left: 7px;
        white-space: nowrap;
      }
    }
  }
  .extLinks {
    /* position: absolute; */
    /* right: 330px; */
    /* top: 0px; */
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    &.active {
      opacity: 0;
    }
    img {
      margin: 0 5px;
      @media only screen and (max-width: $md) {
        display: none;
      }
    }
    span {
      font-family: "Futura";
      color: $grey-blue;
      font-size: 14px;
      margin: 0 0 0 25px;
      @media only screen and (max-width: $md) {
        display: none;
      }
    }
    .renewBtn {
      margin: 0 30px;
      a {
        font-family: "Futura";
        font-size: 14px;
        color: #fff;
        border: 2px solid $yellow;
        border-radius: 25px;
        padding: 8px 20px;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  .primaryNav {
    position: absolute;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: none;
    visibility: hidden;
    opacity: 0;
    z-index: 1000;
    transition: all 0.5s ease-in-out;
    &.active {
      visibility: visible;
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.5);
    }
    #primary-nav {
      position: fixed;
      height: 100%;
      width: 350px;
      top: 0;
      left: -100%;
      background-color: #fff;
      transition: all 0.3s ease-in-out;
      @media (max-width: $xl) {
        padding-right: 6.2vw;
      }
      &.active {
        left: 0;
      }
      .topNavLogos {
        position: absolute;
        top: 20px;
        left: 20px;
        h2,
        h4 {
          font-family: "Antique Olive";
          font-style: normal;
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          text-transform: uppercase;
          color: #00285e;
        }
        h4 {
          color: #79bde8;
        }
      }
      /**Adjust this padding for mobile, remove and justify center */
      .p-nav-links {
        height: 100%;
        background: transparent;
        padding-top: 250px;
        @media (max-width: $md) {
          padding-top: 100px;
        }
        .highlight {
          height: 3px;
          width: 100%;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          background: #ffffff;
          box-shadow: inset 0 -2px 1px 0 rgba(0, 0, 0, 0.41);
        }

        .p-nav-link {
          position: relative;
          height: 100%;
          padding: 0 0 0 5px;
          a {
            font-family: "Futura";
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            text-transform: uppercase;
            color: #161e26;
            opacity: 0.7;
            &:hover {
              opacity: 1;
            }
          }
        }
        .active {
          a {
            color: $dark-blue;
            opacity: 1;
          }
        }
      }
      .bottomIcons {
        position: absolute;
        bottom: 15px;
        display: flex;
        a {
          padding: 0 15px;
        }
      }
    }
  }
  .navOverlay {
    position: absolute;
    right: 0;
    width: 75vw;
    height: 100vh;
    background-color: none;
    visibility: hidden;
    opacity: 0;
    z-index: 1003;
    transition: all 0.5s ease-in-out;
    @media only screen and (max-width: $xl) {
      width: 65vw;
    }
    @media only screen and (max-width: $lg) {
      width: 58vw;
    }
    @media only screen and (max-width: $md) {
      width: 25vw;
    }
    @media only screen and (max-width: $sm) {
      width: 10vw;
    }
    &.active {
      visibility: visible;
      opacity: 1;
      background-color: none;
    }
  }
}
</style>
